module.exports = __webpack_public_path__ + "img/labeled-samples-bg.170ae9e0.jpg";